export default __webpack_public_path__ + "static/media/pexels-anthonyshkraba-production-8278885.a1d9001f.jpg";